export function getDashboardPathForRole(role) {
  switch (role) {
    case 'super_admin':
      return '/admin/dashboard';
    case 'wl_admin':
      return '/whitelabel/dashboard';
    case 'employee':
      return '/employee/dashboard';
    case 'agent':
      return '/agent/dashboard';
    default:
      return '/login';
  }
}

export function canImpersonateUser(currentUser, targetUser) {
  if (!currentUser || !targetUser || currentUser.impersonation?.active) {
    return false;
  }

  const actorRole = currentUser.role;
  const targetRole = targetUser.userRole || targetUser.roleKey || targetUser.role;

  if (actorRole === 'super_admin') {
    return targetRole === 'employee' || targetRole === 'agent';
  }

  if (actorRole === 'wl_admin') {
    return (
      (targetRole === 'employee' || targetRole === 'agent')
      && currentUser.white_label_id
      && currentUser.white_label_id === targetUser.whiteLabelId
    );
  }

  if (actorRole === 'employee') {
    return targetRole === 'agent' && targetUser.createdById === currentUser.id;
  }

  return false;
}

export function getImpersonationDisplayName(user) {
  if (!user) return '';
  const workspaceName = user?.impersonation?.target?.workspace_name;
  const parts = [user.full_name, user.email];
  if (workspaceName) {
    parts.push(workspaceName);
  }
  return parts.filter(Boolean).join(' | ');
}
